(() => {
  if (window.AceProductVariantTitle) return;
  const tokenCharacter = /[A-Za-z0-9_./-]/;
  function titleForVariant(title, skus, selectedSku) {
    if (typeof title !== 'string' || !Array.isArray(skus)) return title || '';
    const knownSkus = [...new Set(skus)].filter(x => typeof x === 'string' && x.length > 0);
    const candidates = new Set(knownSkus);
    for (const item of title.matchAll(/[A-Za-z0-9]+(?:[-_/][A-Za-z0-9]+)*/g)) {
      const code=item[0];
      if(code.length>=5&&/[A-Za-z]/.test(code)&&/\d/.test(code)&&knownSkus.length&&knownSkus.every(sku=>sku.startsWith(code))) candidates.add(code);
    }
    const matches = [];
    for (const sku of [...candidates].sort((a,b) => b.length-a.length)) {
      let start = 0;
      while ((start = title.indexOf(sku, start)) !== -1) {
        const end = start + sku.length;
        if ((start === 0 || !tokenCharacter.test(title[start-1])) && (end === title.length || !tokenCharacter.test(title[end]))) matches.push({sku,start,end});
        start = end;
      }
    }
    if (!matches.length || new Set(matches.map(x=>x.sku)).size !== 1) return title;
    const sku = typeof selectedSku === 'string' ? selectedSku.trim() : '';
    let result = title;
    for (const match of matches.sort((a,b)=>b.start-a.start)) result = result.slice(0,match.start) + sku + result.slice(match.end);
    return sku ? result : result.replace(/\(\s*\)|（\s*）|\[\s*\]|【\s*】/g,'').replace(/\s{2,}/g,' ').trim();
  }
  function metadata(root) {
    const node = root.querySelector('[data-ace-title-meta]');
    if (!node) return null;
    try { return { title:node.dataset.title, skus:JSON.parse(node.dataset.skus), selected:{id:node.dataset.variantId,sku:node.dataset.variantSku} }; } catch { return null; }
  }
  function update(root, variant) {
    const data=metadata(root); if (!data) return null;
    const title=titleForVariant(data.title,data.skus,variant?.sku);
    root.querySelectorAll('[data-ace-variant-title]').forEach(node=>{node.textContent=title;});
    root.querySelectorAll('[data-ace-selected-sku]').forEach(node=>{node.textContent=variant?.sku || '';});
    root.querySelectorAll('[data-ace-selected-sku-row]').forEach(node=>{node.hidden=!variant?.sku;node.classList.toggle('visibility-hidden',!variant?.sku);});
    if(root.dataset.updateUrl==='true') document.title=titleForVariant(document.title,data.skus,variant?.sku);
    return title;
  }
  window.AceProductVariantTitle=Object.freeze({titleForVariant,metadata,update});
})();
if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.updateInquiryVariant(this.getVariantSelects(this) ? this.getSelectedVariant(this) : window.AceProductVariantTitle.metadata(this)?.selected);
        this.aceHistoryHandler = this.syncHistoryVariant.bind(this);
        window.addEventListener('popstate', this.aceHistoryHandler);
        window.addEventListener('pageshow', this.aceHistoryHandler);
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
        window.removeEventListener('popstate', this.aceHistoryHandler);
        window.removeEventListener('pageshow', this.aceHistoryHandler);
        this.aceRequestSequence = (this.aceRequestSequence || 0) + 1;
        this.abortController?.abort();
      }

      syncHistoryVariant(event) {
        if (this.dataset.updateUrl !== 'true' || (event.type === 'pageshow' && !event.persisted)) return;
        const product = new URL(this.dataset.url, location.origin);
        if (product.origin !== location.origin || product.pathname !== location.pathname) return;
        const id = new URL(location.href).searchParams.get('variant');
        if (id && !/^\d{1,20}$/.test(id)) return;
        const current = this.getSelectedVariant(this);
        if (id && String(current?.id) === id) { this.updateInquiryVariant(current); return; }
        product.searchParams.set('section_id', this.sectionId);
        if (id) product.searchParams.set('variant', id);
        this.resetProductFormState();
        this.renderProductInfo({requestUrl:product.href,callback:this.handleUpdateProductInfo(this.dataset.url, false)});
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const sourceProductInfo = html.querySelector(selector);
          const variant = this.getSelectedVariant(sourceProductInfo);
          this.variantSelectors?.resolvePendingSelectPromise(variant, this.getVariantSelects(sourceProductInfo));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.title = html.querySelector('head title')?.textContent || document.title;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const requestSequence = this.aceRequestSequence = (this.aceRequestSequence || 0) + 1;

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            if (requestSequence !== this.aceRequestSequence || !this.isConnected) return;
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
            // set focus to last clicked option value
            if (targetId) document.getElementById(targetId)?.focus();
          })
          .catch((error) => {
            if (requestSequence !== this.aceRequestSequence || !this.isConnected) return;
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
            this.variantSelectors?.rejectPendingSelectPromise(error);
          });
      }

      parseJsonScript(parent, selector) {
        try {
          return JSON.parse(parent?.querySelector(selector)?.textContent);
        } catch {
          return null;
        }
      }

      getVariantSelects(queryRoot) {
        return queryRoot?.querySelector('variant-selects');
      }

      getSelectedVariant(productInfoNode) {
        return this.parseJsonScript(this.getVariantSelects(productInfoNode), '[data-selected-variant]');
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl, updateHistory = true) {
        return (html) => {
          const sourceVariantSelects = this.getVariantSelects(html);
          const variant = this.getSelectedVariant(html);
          const titleSource = html.querySelector('[data-ace-title-meta]');
          const titleTarget = this.querySelector('[data-ace-title-meta]');
          if (titleSource && titleTarget) for (const key of ['title','skus','variantId','variantSku']) titleTarget.dataset[key] = titleSource.dataset[key] || '';

          // Resolve product:select promise before updateOptionValues replaces the variant-selects DOM element
          this.variantSelectors?.resolvePendingSelectPromise(variant, sourceVariantSelects);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          if (updateHistory) this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.updateInquiryVariant(variant);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          this.updateMemberPriceLinks(variant);
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateInquiryVariant(variant) {
        const displayTitle = window.AceProductVariantTitle.update(this, variant);
        let productUrl;
        try {
          productUrl = new URL(this.dataset.url, window.location.origin);
        } catch {
          return;
        }
        this.querySelectorAll('a[data-ace-inquiry-link]').forEach((link) => {
          try {
            const destination = new URL(link.href, window.location.origin);
            const target = new URL(destination.searchParams.get('product_url'), window.location.origin);
            if (destination.origin !== window.location.origin || target.origin !== productUrl.origin || target.pathname !== productUrl.pathname) return;
            const variantId = String(variant?.id || '');
            const selectedPath = productUrl.pathname + (/^\d{1,20}$/.test(variantId) ? `?variant=${variantId}` : '');
            const source = new URL(destination.searchParams.get('source_url') || productUrl.pathname, window.location.origin);
            destination.searchParams.set('product_sku', variant?.sku || '');
            if (displayTitle) { destination.searchParams.set('product_name', displayTitle); destination.searchParams.set('source_title', displayTitle); }
            destination.searchParams.set('product_url', selectedPath);
            destination.searchParams.set('source_url', selectedPath + (source.pathname === productUrl.pathname ? source.hash : ''));
            link.href = destination.href;
          } catch {}
        });
      }

      updateMemberPriceLinks(variant) {
        let productUrl;
        try {
          productUrl = new URL(this.dataset.url, window.location.origin);
        } catch {
          return;
        }
        const variantId = String(variant?.id || '');
        const returnTo = productUrl.pathname + (/^\d{1,20}$/.test(variantId) ? `?variant=${variantId}` : '');
        this.querySelectorAll('.ace-member-price a[href]').forEach((link) => {
          try {
            const destination = new URL(link.href, window.location.origin);
            if (destination.origin !== window.location.origin || !destination.searchParams.has('return_to')) return;
            destination.searchParams.set('return_to', returnTo);
            link.href = destination.href;
          } catch {}
        });
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === '.quantity__label') {
              const updatedAriaLabelledBy = updated.getAttribute('aria-labelledby');
              if (updatedAriaLabelledBy) {
                current.setAttribute('aria-labelledby', updatedAriaLabelledBy);
                // Update the referenced visually hidden element
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
